import {Modal} from 'react-bootstrap'
import ModalHeader from 'components/Modal/ModalHeader'
import {getFormValues, isValid} from 'redux-form'
import {connect} from 'react-redux'
import {onCancelLibraryInventoryAlertModal, onConfirmLibraryInventoryAlertModal} from 'actions/ingredients/library'
import styles from './LibraryInventoryAlertModal.css'
import {Link} from 'react-router'
import LibraryInventoryForm from './LibraryInventoryForm.js'

class LibraryInventoryAlertModal extends React.Component {
  render () {
    const {showLibraryInventoryAlertModal, units, libraryForm} = this.props
    return (<Modal show={showLibraryInventoryAlertModal} backdrop='static' onHide={this._onCancel} dialogClassName={`modal-dialog ${styles.dialog}`}>
      <ModalHeader title={'Manage Ingredient Inventory'} />
      <Modal.Body>
        <LibraryInventoryForm libraryForm={libraryForm} units={units} />
      </Modal.Body>
      <Modal.Footer>
        <span className='pull-left'>
          <button className='btn btn-default' onClick={this._onCancel}>Cancel</button>
        </span>
        <span className='pull-right'>
          <button className='btn btn-primary' onClick={this._onSave}>Confirm</button>
        </span>
        <i className={styles['footer-info']}>*Use the <Link to='/inventory/summary' target='blank'>Inventory page</Link> to manage stock</i>
      </Modal.Footer>
    </Modal>)
  }

  _onCancel = () => {
    const {dispatch} = this.props
    dispatch(onCancelLibraryInventoryAlertModal())
  }

  _onSave = () => {
    const {dispatch, libraryInventoryForm, validForm, libraryForm} = this.props
    if (validForm) {
      dispatch(onConfirmLibraryInventoryAlertModal(libraryInventoryForm, libraryForm))
    }
  }
}

function mapStateToProps (state) {
  const {showLibraryInventoryAlertModal, previousLibraryForm, units} = state.ingredients.library
  return {
    showLibraryInventoryAlertModal,
    previousLibraryForm,
    units,
    libraryForm: getFormValues('library')(state),
    libraryInventoryForm: getFormValues('libraryInventory')(state),
    validForm: isValid('libraryInventory')(state)
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(LibraryInventoryAlertModal)



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Library/LibraryDetail/LibraryForm/LibraryInventoryAlertModal/LibraryInventoryAlertModal.js